import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d805a402"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dashboard-right-column" }

import DashboardSummaryGrid from '@/components/dashboard/DashboardSummaryGrid.vue';
import RecentActivitiesWidget from '@/components/dashboard/RecentActivitiesWidget.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardRightColumn',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(DashboardSummaryGrid, { compact: "" }),
    _createVNode(RecentActivitiesWidget, { compact: "" })
  ]))
}
}

})